import {useEffect} from "react";
import {useNeurotuneStore} from "@/common/store/neurotune.ts";
import {isTauriAvailable} from "@/common/utils/tauri";
import {NIL as nilUUID} from 'uuid';

/**
 * Hook to wire any required Tauri event listeners when activeCompany
 * is available. Currently a no-op (the legacy `acquisition_error`
 * listener was removed when the daqStatusMap was retired). Kept as
 * the canonical mount point for future app-level Tauri listeners so
 * callers don't have to be re-threaded.
 *
 * IMPORTANT: This hook should only be called once, typically at the
 * app level after the user has logged in and activeCompany is set.
 */
export const useTauriListeners = () => {
    const activeCompany = useNeurotuneStore((state) => state.activeCompany);
    const isLoggedIn = activeCompany.id !== nilUUID

    useEffect(() => {
        if (!isTauriAvailable()) {
            return;
        }

        // Only initialize listeners after company is set (user is logged in)
        if (!isLoggedIn) {
            return;
        }

        console.log('[TauriListeners] Initializing listeners with company:', activeCompany.id);
    }, [activeCompany.id, isLoggedIn]);
};